/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const RtSystemCategory = {
    QaEquipment: 'QaEquipment',
    TreatmentMachine: 'TreatmentMachine',
    ImagingMachine: 'ImagingMachine',
    OtherMedicalSystem: 'OtherMedicalSystem',
    Software: 'Software'
} as const;
export type RtSystemCategory = typeof RtSystemCategory[keyof typeof RtSystemCategory];


export function RtSystemCategoryFromJSON(json: any): RtSystemCategory {
    return RtSystemCategoryFromJSONTyped(json, false);
}

export function RtSystemCategoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): RtSystemCategory {
    return json as RtSystemCategory;
}

export function RtSystemCategoryToJSON(value?: RtSystemCategory | null): any {
    return value as any;
}

/**
 * Check if a given object implements the RtSystemCategory interface.
 */
 export function instanceOfRtSystemCategory(value: any): value is RtSystemCategory {
    return Object.values(RtSystemCategory).includes(value)
}

